module.exports = __webpack_public_path__ + "65783120df614e2457c6b05e51e79fa3.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-07-19/whats-new.html
// module id = 2240
// module chunks = 0